/**
 * Sticky component constructor
 * @param $element
 * @param targets
 * @param event
 * @param auto
 * @param breakpoint
 * @constructor
 */
class Toggles {
    constructor($element, targets, group, event, auto, breakpoint) {
        this._$el = $element;
        this._targets = targets;
        this._event = event;
        this._group = group ? group : undefined;
        this._breakpoint = breakpoint;

        /**
         * Auto-toggle as soon as we hit an `auto` = true
         */
        if (auto === true) {
            return this.toggle();
        }

        this._$el.on('click', this.toggle.bind(this));
    }

    /**
     * Toggle the toggleClass on the target
     */
    toggle() {


        if (
            this._breakpoint !== undefined &&
            this._$el.data('toggles-breakpoint') !== undefined &&
            this._$el.data('toggles-breakpoint').split(',').indexOf(this._breakpoint()) === -1
        ) {
            return true;
        }

        for (const selector in this._targets) {
            const $target = selector === 'this' ? this._$el : $(selector), className = this._targets[selector];

            if (className instanceof Array === true) {
                className.map(e => {
                    this._toggleElement($target, e);
                });
            } else {
                if (this._group) $(this._group).removeClass(className);

                this._toggleElement($target, className);
            }
        }

        if (this._event !== undefined) {
            this._fireEvent(this._event);
        }
    }

    /**
     * Toggle a specific class on a target element
     * @param $target
     * @param className
     * @private
     */
    _toggleElement($target, className) {
        $target.toggleClass(className);
    }

    /**
     * Fire the event on the window object
     * @param event
     * @private
     */
    _fireEvent(event) {
        $(window).trigger(event);
    }

    /**
     * Attach new toggle
     * @private
     */
    _attach() {
        const $el = $(this),
            targets = $el.data('toggles'),
            event = $el.data('toggles-event'),
            group = $el.data('toggles-group'),
            auto = $el[0].hasAttribute('data-toggles-auto') || false;

        new Toggles($el, targets, group, event, auto, window.breakpoint);
    }
}

export default Toggles;
